import React from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';

export default class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    this.sendPageView(this.context.router.history.location);
    this.context.router.history.listen(this.sendPageView);
  }

  sendPageView(location) {
    ReactGA.set({ page: location.pathname }, ['tracker1', 'tracker2']);
    ReactGA.pageview(location.pathname, ['tracker1', 'tracker2']);
  }

  render() {
    return this.props.children;
  }
}